// import React from 'react';
// import { Box } from '@chakra-ui/react';

// interface JaggedBorderProps {
//   bgColor?: string;
// }

// export const JaggedBorderHeader: React.FC<JaggedBorderProps> = ({ bgColor = 'white' }) => {
//   return (
//     <Box position="absolute" bottom="-1" width="100%" height="60px" zIndex="1" overflow="hidden">
//       <Box
//         position="absolute"
//         top="0"
//         left="50%"
//         height="100%"
//         zIndex={1}
//         transform="translateX(-50%)"
//         minWidth="1920px"
//         width="100%"
//       >
//         {/* Fill Background */}
//         <Box position="absolute" top="0" left="0" width="100%" height="100%" zIndex={1}>
//           <svg
//             viewBox="0 0 1920 71"
//             width="100%"
//             height="100%"
//             preserveAspectRatio="none"
//             xmlns="http://www.w3.org/2000/svg"
//           >
//             <path
//               d="M1946 35.1591L1794.98 30.0975L1740.98 39.3803L1767.14 12.3721L1584.85 48.8159L1525.29 37.6134L1539.54 59.0001L1406.89 31.783L1435.18 55.4356L1158.84 30.9377L1087.97 52.8794L1101.47 23.3455L968.874 38.1226L929.36 19.9694L744.375 39.6502L720.128 27.5616L664.96 40.1594L674.566 18.2789L558.982 24.1907L493.175 36.8445L466.178 25.0309L325.921 36.595L272.469 26.92L197.636 44.7423L247.524 16.736L45.9332 38.6318L-51 27.5616L-51 100L1946 100Z"
//               fill={bgColor}
//             />
//           </svg>
//         </Box>
//       </Box>

//       <Box
//         position="absolute"
//         top="0"
//         left="50%"
//         height="100%"
//         zIndex={2}
//         transform="translateX(-50%)"
//         minWidth="1920px"
//       >
//         {/* Gradient Stroke Path */}
//         <svg
//           viewBox="0 0 1920 71"
//           width="100%"
//           height="100%"
//           preserveAspectRatio="none"
//           xmlns="http://www.w3.org/2000/svg"
//         >
//           <defs>
//             <linearGradient
//               id="jagged-gradient"
//               x1="-51"
//               y1="35.6861"
//               x2="1946"
//               y2="35.6861"
//               gradientUnits="userSpaceOnUse"
//             >
//               <stop stopColor="#4371D4" />
//               <stop offset="0.201923" stopColor="#8934C4" />
//               <stop offset="0.495192" stopColor="#3D99E0" />
//               <stop offset="0.8" stopColor="#8934C4" />
//               <stop offset="1" stopColor="#4272D4" />
//             </linearGradient>
//           </defs>
//           <path
//             d="M1946 35.1591L1794.98 30.0975L1740.98 39.3803L1767.14 12.3721L1584.85 48.8159L1525.29 37.6134L1539.54 59.0001L1406.89 31.783L1435.18 55.4356L1158.84 30.9377L1087.97 52.8794L1101.47 23.3455L968.874 38.1226L929.36 19.9694L744.375 39.6502L720.128 27.5616L664.96 40.1594L674.566 18.2789L558.982 24.1907L493.175 36.8445L466.178 25.0309L325.921 36.595L272.469 26.92L197.636 44.7423L247.524 16.736L45.9332 38.6318L-51 27.5616"
//             stroke="url(#jagged-gradient)"
//             strokeWidth="15"
//             strokeLinejoin="miter"
//             strokeLinecap="butt"
//             fill="none"
//           />
//         </svg>
//       </Box>
//     </Box>
//   );
// };

import React from 'react';
import { Box, useBreakpointValue } from '@chakra-ui/react';

interface JaggedBorderProps {
  bgColor?: string;
}

export const JaggedBorderHeader: React.FC<JaggedBorderProps> = ({ bgColor = 'white' }) => {
  const responsiveWidth = useBreakpointValue({
    base: '1920px', // crop on small screens
    xl: '100%', // stretch on large screens
  });

  return (
    <Box position="absolute" bottom="-1" width="100%" height="60px" zIndex="1" overflow="hidden">
      {/* White Fill */}
      <Box
        position="absolute"
        top="0"
        right="0"
        left="auto"
        width={responsiveWidth}
        height="100%"
        zIndex={1}
        transform={{
          base: 'translateX(+4%) scaleX(0.92)',
          xl: 'translateX(0) scaleX(1)',
        }}
      >
        <svg
          viewBox="0 0 1920 71"
          width="100%"
          height="100%"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1946 35.1591L1794.98 30.0975L1740.98 39.3803L1767.14 12.3721L1584.85 48.8159L1525.29 37.6134L1539.54 59.0001L1406.89 31.783L1435.18 55.4356L1158.84 30.9377L1087.97 52.8794L1101.47 23.3455L968.874 38.1226L929.36 19.9694L744.375 39.6502L720.128 27.5616L664.96 40.1594L674.566 18.2789L558.982 24.1907L493.175 36.8445L466.178 25.0309L325.921 36.595L272.469 26.92L197.636 44.7423L247.524 16.736L45.9332 38.6318L-51 27.5616L-51 100L1946 100Z"
            fill={bgColor}
          />
        </svg>
      </Box>

      {/* Gradient Stroke */}
      <Box
        position="absolute"
        top="0"
        right="0"
        left="auto"
        width={responsiveWidth}
        height="100%"
        zIndex={2}
        transform={{
          base: 'translateX(+4%) scaleX(0.92)',
          xl: 'translateX(0) scaleX(1)',
        }}
      >
        <svg
          viewBox="0 0 1920 71"
          width="100%"
          height="100%"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient
              id="jagged-gradient"
              x1="-51"
              y1="35.6861"
              x2="1946"
              y2="35.6861"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#4371D4" />
              <stop offset="0.201923" stopColor="#8934C4" />
              <stop offset="0.495192" stopColor="#3D99E0" />
              <stop offset="0.8" stopColor="#8934C4" />
              <stop offset="1" stopColor="#4272D4" />
            </linearGradient>
          </defs>
          <path
            d="M1946 35.1591L1794.98 30.0975L1740.98 39.3803L1767.14 12.3721L1584.85 48.8159L1525.29 37.6134L1539.54 59.0001L1406.89 31.783L1435.18 55.4356L1158.84 30.9377L1087.97 52.8794L1101.47 23.3455L968.874 38.1226L929.36 19.9694L744.375 39.6502L720.128 27.5616L664.96 40.1594L674.566 18.2789L558.982 24.1907L493.175 36.8445L466.178 25.0309L325.921 36.595L272.469 26.92L197.636 44.7423L247.524 16.736L45.9332 38.6318L-51 27.5616"
            stroke="url(#jagged-gradient)"
            strokeWidth="15"
            strokeLinejoin="miter"
            strokeLinecap="butt"
            fill="none"
          />
        </svg>
      </Box>
    </Box>
  );
};
